import type { WeeklyActionChannel } from "./weeklyActions";

export type WeeklyActionChannelPresentation = {
    label: string;
    description: string;
    icon: string;
    iconClass: string;
};

export type WeeklyActionModePresentation = {
    label: "On your own" | "With Nadia" | "Role play with Nadia";
    icon: string;
    className: "journeys-action-card__tag--own" | "journeys-action-card__tag--nadia";
};

export type WeeklyActionTaxonomyPresentation = {
    label: "Learning resource" | "Role play with Nadia" | "With Nadia" | "In a meeting" | "In your work" | "Weekly reminder";
    icon: string;
    kind: "resource" | "tag";
    className: "journeys-action-card__taxonomy--nadia" | "journeys-action-card__taxonomy--work";
};

const channelPresentations: Record<WeeklyActionChannel, WeeklyActionChannelPresentation> = {
    learning_material: {
        label: "Learning resource",
        description: "A short resource selected to help you prepare for a real opportunity at work.",
        icon: "bi-book",
        iconClass: "bg-sky-100 text-sky-700",
    },
    role_play_with_nadia: {
        label: "Practise with Nadia",
        description: "Rehearse a real conversation with Nadia in a lower-stakes setting first.",
        icon: "bi-person-video2",
        iconClass: "bg-violet-100 text-violet-700",
    },
    conversation_with_nadia: {
        label: "Work with Nadia",
        description: "Use Nadia's coaching support to think through, learn, or create something useful.",
        icon: "bi-chat-square-text",
        iconClass: "bg-amber-100 text-amber-700",
    },
    flow_of_work_meeting: {
        label: "In a meeting",
        description: "Try this in a real conversation or calendar event already in your work.",
        icon: "bi-people",
        iconClass: "bg-blue-100 text-blue-700",
    },
    flow_of_work_activity: {
        label: "In your work",
        description: "Put this into practice in your day-to-day work outside a meeting.",
        icon: "bi-briefcase",
        iconClass: "bg-emerald-100 text-emerald-700",
    },
    action_review_reminder: {
        label: "Weekly reminder",
        description: "Set aside time to reflect on your actions and choose what to focus on next.",
        icon: "bi-bell",
        iconClass: "bg-valence-primary-100 text-valence-primary-700",
    },
};

const actionModePresentations: Record<WeeklyActionChannel, WeeklyActionModePresentation> = {
    learning_material: {
        label: "On your own",
        icon: "bi-pencil",
        className: "journeys-action-card__tag--own",
    },
    role_play_with_nadia: {
        label: "Role play with Nadia",
        icon: "bi-chat",
        className: "journeys-action-card__tag--nadia",
    },
    conversation_with_nadia: {
        label: "With Nadia",
        icon: "bi-chat",
        className: "journeys-action-card__tag--nadia",
    },
    flow_of_work_meeting: {
        label: "On your own",
        icon: "bi-pencil",
        className: "journeys-action-card__tag--own",
    },
    flow_of_work_activity: {
        label: "On your own",
        icon: "bi-pencil",
        className: "journeys-action-card__tag--own",
    },
    action_review_reminder: {
        label: "On your own",
        icon: "bi-pencil",
        className: "journeys-action-card__tag--own",
    },
};

const actionTaxonomyPresentations: Record<WeeklyActionChannel, WeeklyActionTaxonomyPresentation> = {
    learning_material: {
        label: "Learning resource",
        icon: "bi-file-richtext",
        kind: "resource",
        className: "journeys-action-card__taxonomy--work",
    },
    role_play_with_nadia: {
        label: "Role play with Nadia",
        icon: "bi-people",
        kind: "tag",
        className: "journeys-action-card__taxonomy--nadia",
    },
    conversation_with_nadia: {
        label: "With Nadia",
        icon: "bi-chat-left",
        kind: "tag",
        className: "journeys-action-card__taxonomy--nadia",
    },
    flow_of_work_meeting: {
        label: "In a meeting",
        icon: "bi-calendar",
        kind: "tag",
        className: "journeys-action-card__taxonomy--work",
    },
    flow_of_work_activity: {
        label: "In your work",
        icon: "bi-pencil",
        kind: "tag",
        className: "journeys-action-card__taxonomy--work",
    },
    action_review_reminder: {
        label: "Weekly reminder",
        icon: "bi-bell",
        kind: "tag",
        className: "journeys-action-card__taxonomy--work",
    },
};

export const getWeeklyActionChannelPresentation = (channel: WeeklyActionChannel): WeeklyActionChannelPresentation => channelPresentations[channel];
export const getWeeklyActionModePresentation = (channel: WeeklyActionChannel): WeeklyActionModePresentation => actionModePresentations[channel];
export const getWeeklyActionTaxonomyPresentation = (channel: WeeklyActionChannel): WeeklyActionTaxonomyPresentation => actionTaxonomyPresentations[channel];
